import React, { useState } from 'react';
import { trackEvent, trackError } from '../utils/helpers';

const ShareButton = () => {
    const [copied, setCopied] = useState(false);

    const handleShareClick = async (e) => {
        e.stopPropagation();
        
        const shareUrl = window.location.href;
        try {
            await navigator.clipboard.writeText(shareUrl);
            trackEvent('article-shared', {
                url: shareUrl,
                method: 'clipboard'
            });
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 2000);
        } catch (err) {
            console.error('Failed to copy link:', err);
            trackError('share-error', err, {
                url: shareUrl
            });
        }
    };

    return (
        <div className="share-button-container">
            <button 
                className={`share-button ${copied ? 'copied' : ''}`}
                onClick={handleShareClick}
                aria-label={copied ? "Länk kopierad" : "Kopiera länk"}
                title={copied ? "Kopierad!" : "Kopiera länk"}
            >
                {copied ? (
                    <>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 5L8 13L4 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span className="share-button-text">Kopierad!</span>
                    </>
                ) : (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="15" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
                        <circle cx="5" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
                        <circle cx="15" cy="15" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
                        <path d="M7.5 9L12.5 6.5M7.5 11L12.5 13.5" stroke="currentColor" strokeWidth="1.5"/>
                    </svg>
                )}
            </button>
        </div>
    );
};

export default ShareButton;
